<template>
  <GModal class="modal--confirmation-publish">
    <div slot="header">
      <!-- <button type="button" class="close" aria-label="Close"><img src="/assets/img/icons/close-modal.svg" @click.prevent="closeConfirmation" /></button> -->

      <h2 class="modal-heading">Save Review</h2>
    </div>

    <div slot="body">
      <p class="text">
        Periksa ulang yuk review yang sudah dibuat, karena setelah di publish kamu hanya dapat 1x kesempatan untuk
        mengedit review-mu!
      </p>
    </div>

    <div slot="footer">
      <div class="group-btn">
        <div class="col-btn">
          <a href="" class="btn btn-cancel btn-minimal" @click.prevent="closeConfirmation">Cancel</a>
        </div>
        <div class="col-btn">
          <a v-if="!onProgressSubmit" href="" class="btn btn-publish" @click.prevent="updateReview">Save</a>
          <a v-else class="btn btn-publish">Processing..</a>
        </div>
      </div>
    </div>
  </GModal>
</template>

<script>
export default {
  name: 'modal-confirmation-edit',
  data() {
    return {
      onProgressSubmit: false,
    };
  },
  computed: {
    productShot() {
      return this.$store.state.writeReview.productShot;
    },
    productCombinationsAttribute() {
      const combinations = this.review.product ? this.review.product.combination : [];
      const updatedCombinations = [];
      if (combinations && typeof combinations === 'object' && !Array.isArray(combinations)) {
        updatedCombinations.push(combinations);
      }
      return updatedCombinations
        .filter((el) => el != null)
        .map((el) => {
          const variant = [];
          const attributeGroup = ['Shade', 'Variant', 'Size', 'Color', 'Non_specify'];

          if (el.attribute) {
            attributeGroup.forEach((group) => {
              const groupLower = group.toLowerCase();
              const attr = el.attribute[groupLower];
              if (attr && typeof attr === 'object') {
                variant.push({
                  group,
                  ...attr,
                });
              }
            });
          } else if (el.attributes) {
            attributeGroup.forEach((group) => {
              const groupLower = group.toLowerCase();
              const attr = el.attributes[groupLower];
              if (attr && typeof attr === 'object') {
                variant.push({
                  group,
                  ...attr,
                });
              }
            });
          }

          return {
            id: el._id ? el._id : el.id,
            label: variant.map((attr) => attr.name).join(' - '),
            variant: variant.map((attr) => `${attr.group}: ${attr.name}`).join(', '),
            attribute: el.attribute ? el.attribute : el.attributes,
            is_active_in_review: el.is_active_in_review,
          };
        });
      // .filter((el) => el.label && el.is_active_in_review);
    },
    review() {
      return this.$store.state.modal.editReview.data;
    },
  },
  methods: {
    closeConfirmation() {
      this.$store.commit('toggleModalGlobalState', {
        modalName: 'confirmationEdit',
      });
    },
    updateReview() {
      let payload;
      let average_rating = 0;
      const new_review = JSON.parse(JSON.stringify(this.review));

      this.onProgressSubmit = true;

      this.$validator.validateAll().then((response) => {
        if (response) {
          payload = {
            source: window.innerWidth > 1100 ? 'review-web-desktop' : 'review-web-mobile',
            product_id: Number(this.review.product_id),
            details: this.review.details,
            is_recommended: this.review.is_recommended,
            is_repurchase: this.review.is_repurchase,
            images: [],
            product: {
              id: Number(this.review.product_id),
              combination: '',
            },
            tags: [],
            duration_of_used: this.review.duration_of_used,
          };

          new_review.source = payload.source;
          new_review.details = payload.details;
          new_review.is_recommended = payload.is_recommended;
          new_review.is_repurchase = payload.is_repurchase;

          if (this.$SO.size(this.review.product.combination)) {
            this.$SO.each(this.productCombinationsAttribute, (key, combination) => {
              if (combination.id === this.review.product.combination.id) {
                payload.product.combination = this.productCombinationsAttribute[key];
                return false;
              }
            });
          }

          payload.product.variant = payload.product.combination ? payload.product.combination.variant : '';

          if (this.$SO.size(this.productShot)) {
            this.$SO.each(this.productShot, (key, objProduct) => {
              if (objProduct.file) {
                payload.images.push({
                  name: objProduct.file,
                  description: objProduct.caption,
                });
              }
            });

            new_review.images = payload.images;
          }

          if (this.$SO.size(this.review.user)) {
            payload.user = {
              id: this.review.user.id,
              username: this.review.user.user_name,
              name: `${this.review.user.name}`,
            };
          }

          this.$SO.each(this.review.tags, (i, tag) => {
            payload.tags.push({ name: tag.name });
          });

          this.$SO.each(this.review.ratingTypes, (key, prop) => {
            payload[`is_${key}`] = this.review.ratingTypes[key].value;
            new_review[key] = this.review.ratingTypes[key].value;
            average_rating += Number(this.review.ratingTypes[key].value);
          });

          new_review.average_rating = average_rating / this.review.lisRatingTypes.length;
          new_review.counter_star = new_review.average_rating;
          new_review.is_editable = false;
          payload['edited_at'] = new Date();
          if (payload.images.length == 0) {
            delete payload.images;
          }

          this.$MS_SOCO_PUBLIC_API_URL
            .put(`reviews/${this.review['_id']}`, payload)
            .then((response) => {
              if (response.status == '200') {
                const on = /product/.test(this.$route.path) ? 'product' : 'recent';
                this.$store.commit('review/EDIT_REVIEW', {
                  on: on,
                  value: new_review,
                  reviewId: this.review._id,
                });
                this.$toasted.global.show('Review anda berhasil diedit.');
                this.onProgressSubmit = false;
              } else {
                if (response.status == '403') {
                  this.$toasted.global.error('Konten review yang ingin kamu masukkan sudah ada.');
                } else {
                  this.$toasted.global.error('Silakan coba lagi dalam beberapa saat.');
                }
                this.onProgressSubmit = false;
              }

              this.closeConfirmation();
              this.$store.commit('toggleModalGlobalState', {
                modalName: 'editReview',
              });
            })
            .catch((error) => {
              if (error.response) {
                if (error.response && error.response.data && error.response.data.message) {
                  if (error.response.data.errorCode == 'DUPLICATE_USER_REVIEW') {
                    this.$store.commit(
                      'setReviewErrorMessage',
                      'Maaf, Kamu sudah pernah review produk atau produk dengan kombinasi ini sebelumnya.'
                    );
                  } else {
                    this.$store.commit('setReviewErrorMessage', error.response.data.message);
                  }
                  this.$store.commit('toggleModalGlobalState', { modalName: 'reviewError' });
                } else if (error.response.status == 403) {
                  this.$store.commit('setReviewErrorMessage', 'Konten review yang ingin kamu masukkan sudah ada.');
                  this.$store.commit('toggleModalGlobalState', { modalName: 'reviewError' });
                } else {
                  this.$toasted.global.error('Silakan coba lagi dalam beberapa saat.');
                }
              } else {
                this.$toasted.global.error('Silakan coba lagi dalam beberapa saat.');
              }
              this.onProgressSubmit = false;
              this.closeConfirmation();
              // this.$store.commit('toggleModalGlobalState', {
              //   modalName: 'editReview',
              // });
            });
        } else {
          this.onProgressSubmit = false;
          if (document.getElementById(this.$validator.errors.items[0].field)) {
            document.getElementById(this.$validator.errors.items[0].field).scrollIntoView();
            window.scrollBy(0, -85);
          }
        }
      });
    },
  },
};
</script>
